import React from 'react'
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom'
import Authorization from '../../Authentication/Authorization'
import ProtectedRoute from '../../components/ProtectedRoute'
import GatewayType from '../GatewayType'
import TlsKeys from './TlsKeys'
import TrustedTLSIssuer from './TrustedTLSIssuer'

const baseRoute = '/tls'
const subTabs = [
  { path: baseRoute + '/tlsKeys', title: 'TLS Keys', permissions: Authorization.keystore.keys.view, component: TlsKeys },
  { path: baseRoute + '/trustedTLSIssuer', title: 'Trusted TLS Issuer', permissions: Authorization.keystore.trustedTLSIssuer, component: TrustedTLSIssuer },
]

const Tls: GatewayType = () => {
  const match = useRouteMatch()
  return (
    <Switch>
      {subTabs.map((tab) => (
        <ProtectedRoute key={tab.path} path={tab.path} permissions={tab.permissions} Component={tab.component} />
      ))}
      <Route path={match.path}>
        <Redirect to={subTabs[0].path} />
      </Route>
    </Switch>
  )
}

Tls.subTabs = subTabs

export default Tls
